module.exports = __webpack_public_path__ + "img/play.79a1ef3c.svg";